import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  ShareField: {
    fields: {
      /**
       * @note The policy below allows us to avoid cache misses caused by `isEditable` not being returned by
       * a mutation result. `isEditable` is currently only available in the response to a query. See the
       * code comment here
       * https://github.com/Frameio/massdriver/blob/68bf3b248e04b104fdf0d680489855f3a1d5987d/apps/api/lib/api/web/graphql/resolvers/share.ex#L121
       * and the JIRA ticket here https://frame-io.atlassian.net/browse/VIEW-1810
       */
      isEditable: {
        read: (existing) => existing ?? false,
        merge: (existing, incoming) => incoming ?? existing,
      },
    },
  },
};
